import(/* webpackMode: "eager" */ "/opt/ajix-hostel/src/app/not-found.tsx");
